import { colorAccentError700, colorBlackTransparent0, colorBlackTransparent100, colorBlackTransparent400, colorBlackTransparent50, colorBrandYamahaRed, colorCoreBlack900Base, colorCoreGray1000Base, colorCoreWhite1000, colorWhiteTransparent000000, colorWhiteTransparent100, colorWhiteTransparent200, colorWhiteTransparent400, defaultTransparent, } from '@yme/tokens/colors';
import { noop } from '@yme/utils/common';
// button variants
export const CONTAINED_VARIANT = 'CONTAINED_VARIANT';
export const GHOST_VARIANT = 'GHOST_VARIANT';
export const FADED_VARIANT = 'FADED_VARIANT';
export const TEXT_VARIANT = 'TEXT_VARIANT';
// hasIconButton (Options for displaying icon of button)
export const NO_ICON = 'NO_ICON';
export const LEADING_ICON = 'LEADING_ICON';
export const TRAILING_ICON = 'TRAILING_ICON';
export const ICON_ONLY = 'ICON_ONLY';
// button sizes
export const SIZE_36 = '36px';
export const SIZE_40 = '40px';
export const SIZE_44 = '44px';
export const SIZE_48 = '48px';
// Color Schema
export const BTN_LIGHT_THEME = 'BTN_LIGHT_THEME';
export const BTN_DARK_THEME = 'BTN_DARK_THEME';
// Buttons configs
// Contained Button
export const BTN_CONTAINED_CFG = {
    LIGHT: {
        default: {
            bg: colorCoreBlack900Base,
            border: colorCoreBlack900Base,
            color: colorCoreWhite1000,
        },
        hoverActive: {
            bg: colorBrandYamahaRed,
            border: colorBrandYamahaRed,
            color: colorCoreWhite1000,
        },
        disabled: {
            bg: colorBlackTransparent400,
            border: colorCoreGray1000Base,
            color: colorCoreWhite1000,
        },
    },
    DARK: {
        default: {
            bg: colorCoreWhite1000,
            border: colorCoreWhite1000,
            color: colorCoreBlack900Base,
        },
        hoverActive: {
            bg: colorAccentError700,
            border: colorAccentError700,
            color: colorCoreWhite1000,
        },
        disabled: {
            bg: colorWhiteTransparent200,
            border: colorWhiteTransparent200,
            color: colorCoreGray1000Base,
        },
    },
};
// Ghost Button
export const BTN_GHOST_CFG = {
    LIGHT: {
        default: {
            bg: defaultTransparent,
            border: colorCoreBlack900Base,
            color: colorCoreBlack900Base,
        },
        hoverActive: {
            bg: colorCoreBlack900Base,
            border: colorCoreBlack900Base,
            color: colorCoreWhite1000,
        },
        disabled: {
            bg: defaultTransparent,
            border: colorCoreGray1000Base,
            color: colorCoreGray1000Base,
        },
    },
    DARK: {
        default: {
            bg: defaultTransparent,
            border: colorCoreWhite1000,
            color: colorCoreWhite1000,
        },
        hoverActive: {
            bg: colorWhiteTransparent100,
            border: colorCoreWhite1000,
            color: colorCoreWhite1000,
        },
        disabled: {
            bg: defaultTransparent,
            border: colorCoreGray1000Base,
            color: colorCoreGray1000Base,
        },
    },
};
// Faded Button
export const BTN_FADED_CFG = {
    LIGHT: {
        default: {
            bg: colorBlackTransparent50,
            border: colorBlackTransparent0,
            color: colorCoreBlack900Base,
        },
        hoverActive: {
            bg: colorBlackTransparent100,
            border: colorBlackTransparent0,
            color: colorCoreBlack900Base,
        },
        disabled: {
            bg: colorBlackTransparent50,
            border: defaultTransparent,
            color: colorCoreGray1000Base,
        },
    },
    DARK: {
        default: {
            bg: colorWhiteTransparent200,
            border: colorWhiteTransparent000000,
            color: colorCoreWhite1000,
        },
        hoverActive: {
            bg: colorWhiteTransparent400,
            border: colorWhiteTransparent000000,
            color: colorCoreWhite1000,
        },
        disabled: {
            bg: colorWhiteTransparent200,
            border: colorWhiteTransparent000000,
            color: colorCoreGray1000Base,
        },
    },
};
// Text Button
export const BTN_TEXT_CFG = {
    LIGHT: {
        default: {
            bg: defaultTransparent,
            border: colorWhiteTransparent000000,
            color: colorCoreBlack900Base,
        },
        hoverActive: {
            bg: colorBlackTransparent50,
            border: colorWhiteTransparent000000,
            color: colorCoreBlack900Base,
        },
        disabled: {
            bg: defaultTransparent,
            border: colorWhiteTransparent000000,
            color: colorCoreGray1000Base,
        },
    },
    DARK: {
        default: {
            bg: defaultTransparent,
            border: colorWhiteTransparent000000,
            color: colorCoreWhite1000,
        },
        hoverActive: {
            bg: colorWhiteTransparent200,
            border: colorWhiteTransparent000000,
            color: colorCoreWhite1000,
        },
        disabled: {
            bg: defaultTransparent,
            border: colorWhiteTransparent000000,
            color: colorCoreGray1000Base,
        },
    },
};
// Config for sizing of variant buttons
export const DEFAULT_SIZE_CONFIG = {
    BTN_SIZE_36: {
        p: '6px 12px',
        borderRadius: '18px',
        minWidth: '36px',
    },
    BTN_SIZE_40: {
        p: '8px 16px',
        borderRadius: '20px',
        minWidth: '40px',
    },
    BTN_SIZE_44: {
        p: '10px 20px',
        borderRadius: '22px',
        minWidth: '44px',
    },
    BTN_SIZE_48: {
        p: '12px 24px',
        borderRadius: '24px',
        minWidth: '48px',
    },
};
// Config for sizing of variant buttons (button like icon)
export const ONLY_ICONS_SIZE_CONFIG = {
    ONLY_ICON_BTN_SIZE_36: {
        p: '6px',
        borderRadius: '18px',
        widthHeight: '36px',
    },
    ONLY_ICON_BTN_SIZE_40: {
        p: '8px',
        borderRadius: '20px',
        widthHeight: '40px',
    },
    ONLY_ICON_BTN_SIZE_44: {
        p: '10px',
        borderRadius: '22px',
        widthHeight: '44px',
    },
    ONLY_ICON_BTN_SIZE_48: {
        p: '12px',
        borderRadius: '24px',
        widthHeight: '48px',
    },
};
export const DEFAULT_BUTTON_PROPS = {
    label: '',
    onClick: noop,
    isHovered: false,
    isPressed: false,
    disabled: false,
};
